import api from './client';

// ---- Público ----
export const getProducts = (params) => api.get('/products', { params }).then((r) => r.data);
export const getProductFilters = (params) => api.get('/products/filters', { params }).then((r) => r.data);
export const getProduct = (slug) => api.get(`/products/${slug}`).then((r) => r.data);
export const getCategories = () => api.get('/categories').then((r) => r.data);
export const getSettings = () => api.get('/settings').then((r) => r.data);
export const quoteShipping = (province, subtotal, destZip = '') => api.post('/shipping/quote', { province, subtotal, destZip }).then((r) => r.data);
export const quoteCorreo = (destZip, items) => api.post('/shipping/correo/quote', { destZip, items }).then((r) => r.data);
export const correoBranches = (destZip, province, city) => api.post('/shipping/correo/branches', { destZip, province, city }).then((r) => r.data);
export const getPages = () => api.get('/pages').then((r) => r.data);
export const getPage = (slug) => api.get(`/pages/${slug}`).then((r) => r.data);
export const trackCart = (items, subtotal) => api.post('/carts/track', { items, subtotal }).then((r) => r.data);
export const validateCoupon = (code, subtotal) =>
  api.post('/coupons/validate', { code, subtotal }).then((r) => r.data);
// Pedido mayorista (sin pago por ahora; el transporte lo elige el cliente)
export const createWholesaleOrder = (items, notes = '', transport = '') =>
  api.post('/orders/wholesale', { items, notes, transport }).then((r) => r.data);

// ---- Cuenta ----
// Los pedidos se crean vía payments.createPreference (montos validados en backend).
export const getMyOrders = () => api.get('/orders/mine').then((r) => r.data);
export const getOrder = (id) => api.get(`/orders/${id}`).then((r) => r.data);
export const getFavorites = () => api.get('/account/favorites').then((r) => r.data);
export const getAddresses = () => api.get('/account/addresses').then((r) => r.data);
export const addAddress = (payload) => api.post('/account/addresses', payload).then((r) => r.data);
export const updateAddress = (id, payload) => api.put(`/account/addresses/${id}`, payload).then((r) => r.data);
export const deleteAddress = (id) => api.delete(`/account/addresses/${id}`).then((r) => r.data);
export const updateProfile = (payload) => api.put('/auth/profile', payload).then((r) => r.data);

// ---- Pagos (Mercado Pago) ----
export const payments = {
  createPreference: (payload) => api.post('/payments/create-preference', payload).then((r) => r.data),
  getStatus: (orderId) => api.get(`/payments/status/${orderId}`).then((r) => r.data),
  simulate: (orderId, result) => api.post('/payments/simulate', { orderId, result }).then((r) => r.data),
};

// ---- Admin ----
export const admin = {
  dashboard: () => api.get('/admin/dashboard').then((r) => r.data),
  products: (params) => api.get('/admin/products', { params }).then((r) => r.data),
  product: (id) => api.get(`/admin/products/${id}`).then((r) => r.data),
  createProduct: (p) => api.post('/admin/products', p).then((r) => r.data),
  bulkProducts: (ids, action, categoryId) => api.post('/admin/products/bulk', { ids, action, categoryId }).then((r) => r.data),
  reorderProducts: (ids) => api.patch('/admin/products/reorder', { ids }).then((r) => r.data),
  importProducts: (rows) => api.post('/admin/products/import', { rows }).then((r) => r.data),
  importExcelPreview: (file, sheet) => api.post('/admin/products/import-excel/preview', { file, sheet }).then((r) => r.data),
  importExcel: (file, sheet) => api.post('/admin/products/import-excel', { file, sheet }).then((r) => r.data),
  exportProducts: () => api.get('/admin/products/export', { responseType: 'blob' }).then((r) => r.data),
  updateProduct: (id, p) => api.put(`/admin/products/${id}`, p).then((r) => r.data),
  deleteProduct: (id) => api.delete(`/admin/products/${id}`).then((r) => r.data),
  toggleProduct: (id) => api.patch(`/admin/products/${id}/toggle`).then((r) => r.data),
  categories: () => api.get('/admin/categories').then((r) => r.data),
  reorderCategories: (ids) => api.patch('/admin/categories/reorder', { ids }).then((r) => r.data),
  createCategory: (p) => api.post('/admin/categories', p).then((r) => r.data),
  updateCategory: (id, p) => api.put(`/admin/categories/${id}`, p).then((r) => r.data),
  deleteCategory: (id) => api.delete(`/admin/categories/${id}`).then((r) => r.data),
  orders: (params) => api.get('/admin/orders', { params }).then((r) => r.data),
  createOrder: (payload) => api.post('/admin/orders', payload).then((r) => r.data),
  updateOrderStatus: (id, status) => api.patch(`/admin/orders/${id}/status`, { status }).then((r) => r.data),
  fulfillOrder: (id, payload) => api.patch(`/admin/orders/${id}/fulfillment`, payload).then((r) => r.data),
  generateCorreoShipment: (id) => api.post(`/admin/orders/${id}/correo-shipment`).then((r) => r.data),
  bulkGenerateCorreoShipments: (ids) => api.post('/admin/orders/bulk/correo-shipment', { ids }).then((r) => r.data),
  addOrderNote: (id, text) => api.post(`/admin/orders/${id}/notes`, { text }).then((r) => r.data),
  payments: (params) => api.get('/admin/payments', { params }).then((r) => r.data),
  refundPayment: (orderId) => api.post(`/admin/payments/${orderId}/refund`).then((r) => r.data),
  emails: () => api.get('/admin/emails').then((r) => r.data),
  customers: (params) => api.get('/admin/customers', { params }).then((r) => r.data),
  customer: (id) => api.get(`/admin/customers/${id}`).then((r) => r.data),
  wholesalers: () => api.get('/admin/wholesalers').then((r) => r.data),
  updateWholesaler: (id, payload) => api.patch(`/admin/wholesalers/${id}`, payload).then((r) => r.data),
  coupons: () => api.get('/admin/coupons').then((r) => r.data),
  createCoupon: (p) => api.post('/admin/coupons', p).then((r) => r.data),
  updateCoupon: (id, p) => api.put(`/admin/coupons/${id}`, p).then((r) => r.data),
  deleteCoupon: (id) => api.delete(`/admin/coupons/${id}`).then((r) => r.data),
  settings: () => api.get('/settings').then((r) => r.data),
  updateSettings: (p) => api.put('/admin/settings', p).then((r) => r.data),
  uploadImage: (image, kind) => api.post('/admin/uploads', { image, kind }).then((r) => r.data),
  banners: () => api.get('/admin/design/banners').then((r) => r.data),
  updateBanners: (banners) => api.put('/admin/design/banners', { banners }).then((r) => r.data),
  staff: () => api.get('/admin/staff').then((r) => r.data),
  createStaff: (p) => api.post('/admin/staff', p).then((r) => r.data),
  updateStaff: (id, p) => api.put(`/admin/staff/${id}`, p).then((r) => r.data),
  activity: (params) => api.get('/admin/activity', { params }).then((r) => r.data),
  // CMS
  pages: () => api.get('/admin/pages').then((r) => r.data),
  createPage: (p) => api.post('/admin/pages', p).then((r) => r.data),
  updatePage: (id, p) => api.put(`/admin/pages/${id}`, p).then((r) => r.data),
  deletePage: (id) => api.delete(`/admin/pages/${id}`).then((r) => r.data),
  // Carritos
  carts: () => api.get('/admin/carts').then((r) => r.data),
  remindCart: (id) => api.post(`/admin/carts/${id}/remind`).then((r) => r.data),
  shippingZones: () => api.get('/admin/shipping/zones').then((r) => r.data),
  correoStatus: () => api.get('/admin/shipping/correo/status').then((r) => r.data),
  createZone: (p) => api.post('/admin/shipping/zones', p).then((r) => r.data),
  updateZone: (id, p) => api.put(`/admin/shipping/zones/${id}`, p).then((r) => r.data),
  deleteZone: (id) => api.delete(`/admin/shipping/zones/${id}`).then((r) => r.data),
};
